import {RemoteGetDoctorVisitsList} from 'data/usecases/private/my-hospitalization/remote-get-doctor-visits-list';
import {GetDoctorVisitsList} from 'domain/usecases/private/my-hospitalization/get-doctor-visits-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetDoctorVisitsList = (): GetDoctorVisitsList =>
	new RemoteGetDoctorVisitsList(
		makeBFFApiUrl(MyHospitalizationEndpoints.doctorVisitsList),
		makeAuthorizeHttpClientDecorator(),
	);
